// Client half of StaticImages (app/services/static_images.rb): when the layout
// renders a static-image-base-url meta tag, root-relative image paths load from
// the static mirror instead of this app. No tag = paths stay as they are.

const IMAGE_PATH = /^\/(?!\/)[^?#]+\.(?:png|webp|jpe?g|gif|svg)(?:[?#].*)?$/i

const baseUrl = () => document.querySelector('meta[name="static-image-base-url"]')?.content || ""

export function staticImageUrl(path) {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//") ? baseUrl() + path : path
}

// Rewrites every root-relative image path in parsed tool data (gamedata.json
// holds sprite paths like "/tools/.../img/items/Foo.webp?v=…").
export function rebaseImagePaths(data) {
  if (!baseUrl()) return data
  if (typeof data === "string") return IMAGE_PATH.test(data) ? staticImageUrl(data) : data
  if (Array.isArray(data)) return data.map(rebaseImagePaths)
  if (data && typeof data === "object") {
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, rebaseImagePaths(value)]))
  }
  return data
}
